export const LOAD_PARTNER_BANK_ACCOUNTS_SUCCEEDED = "LOAD_PARTNER_BANK_ACCOUNTS_SUCCEEDED";
export const UPDATE_PARTNER_BANK_ACCOUNTS_STARTED = "UPDATE_BANK_ACCOUNTS_STARTED";
export const UPDATE_PARTNER_BANK_ACCOUNTS_SUCCEEDED = "UPDATE_BANK_ACCOUNTS_SUCCEEDED";
